/** "New" beside a menu link: a small dot in the accent colour, with a word for
 *  screen readers. Used by the bar (server) and the side panel (client), so it
 *  holds no state and imports nothing either side cannot. */
export function UnreadDot({ label, className = "" }: { label: string; className?: string }) {
  return (
    <span className={`inline-flex items-center ${className}`}>
      <span aria-hidden="true" className="size-2 rounded-full bg-signal dark:bg-signal-text" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
